module.exports = __webpack_public_path__ + "img/notfound.48e0aa2a.png";